import { Image, Stack, Text, Title } from "@mantine/core"

import {
  CommunicationStudioClasses,
  CUSTOMISATION_CATEGORIES,
} from "@tfg/types/constants/communication-studio.constant"
import { MainHeaderComponentCustomisationConfiguration } from "@tfg/types/schemas/communication-studio/configurationParameters"
import { TextTransform } from "@tfg/types/schemas/communication-studio/cssStylesSchema"
import {
  headerFontFamilyCSSVariable,
  headerFontWeightCSSVariable,
  headerLineHeightCSSVariable,
  titleColorCSSVariable,
} from "@tfg/types/schemas/communication-studio/cssVariables"

import { Hanger } from "../../../icons/hangerIcon"
import { Shoe } from "../../../icons/shoeIcon"
import { useGetStylingParametersContext } from "../context/stylingParameters/useGetStylingParametersContext"
import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

type AGECHeaderWithProductImageProps = {
  image?: string | null
  productName: string
  type?: string
  productReference: string
  withTitle?: boolean
  companyName?: string
} & MainHeaderComponentCustomisationConfiguration

const ProductImage = ({
  src,
  type,
}: {
  src?: string | null
  type?: string
}) => {
  if (!src) {
    return type?.includes("FOOTWEAR") ? (
      <Shoe color="black" size={44} />
    ) : (
      <Hanger color="black" size={44} />
    )
  }
  return (
    <Image w={400} src={src} alt="product-image" style={{ color: "white" }} />
  )
}

export function AGECHeaderWithProductImage({
  image,
  productName,
  productReference,
  type,
  withTitle = true,
  companyName,
  showProductImage,
  showProductReference,
}: AGECHeaderWithProductImageProps) {
  const { stylingParameters } = useGetStylingParametersContext()
  if (!stylingParameters) {
    return null
  }

  return (
    <Stack w="100%" className={CommunicationStudioClasses.MAIN_HEADER}>
      {withTitle ? (
        <Title
          c={DesignStudioParametersToolkit.getCssVariableLiteralName(
            titleColorCSSVariable
          )}
          tt={
            DesignStudioParametersToolkit.extractValueFromCssVariable(
              stylingParameters,
              CUSTOMISATION_CATEGORIES.GLOBAL,
              "headerTextTransform"
            ) as TextTransform | undefined
          }
          fw={DesignStudioParametersToolkit.getCssVariableLiteralName(
            headerFontWeightCSSVariable
          )}
          lh={DesignStudioParametersToolkit.getCssVariableLiteralName(
            headerLineHeightCSSVariable
          )}
          ff={`${DesignStudioParametersToolkit.getCssVariableLiteralName(
            headerFontFamilyCSSVariable
          )}, ${DesignStudioParametersToolkit.extractFontFamily(stylingParameters)}
           `}
        >
          {companyName}
        </Title>
      ) : null}
      {showProductImage ? (
        <Stack align="center">
          <ProductImage src={image} type={type} />
        </Stack>
      ) : null}
      <Stack className={CommunicationStudioClasses.PRODUCT_TITLE}>
        <Text
          className={CommunicationStudioClasses.PRODUCT_NAME}
          style={{ whiteSpace: "nowrap" }}
        >
          {productName}
        </Text>
        {productReference !== productName && showProductReference && (
          <Text className={CommunicationStudioClasses.PRODUCT_REFERENCE}>
            {productReference}
          </Text>
        )}
      </Stack>
    </Stack>
  )
}
